// Mobilní menu
(() => {
    const menuBtn = document.getElementById("menu-btn");
    const menuPanel = document.getElementById("menu-panel");

    function toggleMenu(open) {
        menuBtn.classList.toggle("active", open);
        menuPanel.classList.toggle("active", open);
        document.documentElement.classList.toggle("menu-open", open);
        // Obsah pod menu přes celou obrazovku nesmí jít ovládat ani číst (fokus zůstane v menu)
        document.querySelectorAll("#main, #footer, .skip-link").forEach((el) => {
            el.inert = open;
        });
        menuBtn.setAttribute("aria-expanded", open ? "true" : "false");
    }

    if (menuBtn && menuPanel) {
        menuBtn.addEventListener("click", () => toggleMenu(!menuBtn.classList.contains("active")));

        menuPanel.querySelectorAll("a").forEach((link) => {
            link.addEventListener("click", () => toggleMenu(false));
        });

        document.addEventListener("keydown", (e) => {
            if (e.key === "Escape" && menuBtn.classList.contains("active")) {
                toggleMenu(false);
                menuBtn.focus();
            }
        });

        window.matchMedia("(min-width: 1025px)").addEventListener("change", (e) => {
            if (e.matches) toggleMenu(false);
        });
    }
})();
